import { Routes } from '@angular/router';
import { authGuard } from '@naia/auth-core';

import { remoteRoutes } from './entry.routes';

/**
 * Rutas del arranque STANDALONE (puerto 4400). **Este archivo NO se federa**: bajo el shell las
 * rutas entran por `entry.routes.ts`, que es lo que expone `'./routes'`.
 *
 * Sirve de banco de pruebas de UI sin levantar el shell. No tiene login ni `/unauthorized`: los
 * resuelve el host, así que en este modo no hay sesión propia y el `authGuard` rebota a rutas que
 * acá no existen — es deliberado, no una omisión.
 *
 * Las rutas de negocio son **las mismas** que las federadas, importadas de `entry.routes.ts` para
 * que no puedan divergir: un árbol paralelo escrito a mano acá sería la clase de duplicación que
 * queda desincronizada sin que nada avise.
 */
export const routes: Routes = [
    {
        path: '',
        canActivate: [authGuard],
        children: [...remoteRoutes],
    },
    {
        path: '**',
        redirectTo: 'dashboard',
    },
];
